import { getIn18Text, } from 'api';
import { formatNumberByMax } from '@web-mail/util';
import { thunkHelperFactory } from '@web-common/utils/redux_utils';
import { createCustomerGroupALL, createTreeKey, formatCustomerGroup2TreeData, formatCustomerTreeChild, getCustomerGroupRequestParams, getCustomerSlice, getCustomerTypeBySliceId, getNodeDataByKey, getNodeParentsIdByKey, inserCustomerContact2TreeData, insertCustomer2TreeData, insertGroup2TreeData, parseTreeKey, sliceStateCheck, transCustomerBaseInfo2CustomerTreeData, } from '@web-mail/utils/slice';
import { request } from '@web-mail/state/slice/request';
import { actions as mailTabActions, tabId } from '@web-common/state/reducer/mailTabReducer';
import { transManagerList2ManagerModel, transServerCustomer2CustomerModel, transServerCustomerContact2SimpleContactModel } from '@web-common/utils/contact_util';
import { MAIL_PLUS_CUSTOMER_GROUP_LATEST_CONTACT, MAIL_PLUS_CUSTOMER_GROUP_FAVORITE, MAIL_PLUS_CUSTOMER_GROUP_MONITOR } from '@web-mail/common/constant';
const ReducerName = 'CustomerListReducer';
const Thunks = {};
const ReducersList = [];
const thunkHelper = thunkHelperFactory(ReducerName, Thunks, ReducersList);
thunkHelper({
    name: 'doSearchCustomers_useMailPlusApi',
    request: async (params, thunkAPI) => {
        const { query, pageSize, pageNum, sliceId } = params || {};
        const state = thunkAPI.getState().mailReducer;
        if (!sliceStateCheck(state, sliceId, 'customer')) {
            return;
        }
        const keyword = query || state.customer[sliceId].searchValue;
        const res = await request.doSearchCustomerPage({
            keyword,
            pageSize,
            page: pageNum,
            viewType: getCustomerTypeBySliceId(sliceId),
        });
        console.log('[doSearchCustomers_useMailPlusApi]', res);
        const { data, pageNum: pageNumRes, pageSize: pageSizeRes, totalNum, totalSize } = res;
        return {
            res: data,
            query,
            pageSize: pageSizeRes,
            pageNum: pageNumRes,
            totalNum,
            totalSize,
            sliceId,
        };
    },
    fulfilled: (state, action) => {
        const { res, query, pageNum, totalNum, sliceId } = action.payload || {};
        const newTreeList = transCustomerBaseInfo2CustomerTreeData(res);
        const map = {};
        if (!sliceStateCheck(state, sliceId, 'customer')) {
            return;
        }
        if (state.customer[sliceId].searchTreeList && state.customer[sliceId].searchTreeList.length) {
            state.customer[sliceId].searchTreeList.forEach(item => {
                map[item.key] = true;
            });
        }
        const noMore = pageNum < totalNum;
        state.customer[sliceId].searchTreeListHasMore = !noMore;
        if (!noMore) {
            state.customer[sliceId].searchTreeListPageNum = pageNum;
        }
        if (!query) {
            state.customer[sliceId].searchTreeList = [...state.customer[sliceId].searchTreeList, ...newTreeList.filter(item => !map[item.key])];
        }
        else {
            state.customer[sliceId].searchTreeList = newTreeList;
        }
        state.customer[sliceId].customerSearchListLoading = false;
        state.customer[sliceId].refreshBtnLoading = false;
    },
    rejected: (state, action) => {
        const params = action.meta.arg || {};
        const { sliceId } = params;
        if (!sliceStateCheck(state, sliceId, 'customer')) {
            return;
        }
        state.customer[sliceId].customerSearchListLoading = false;
        state.customer[sliceId].refreshBtnLoading = false;
    },
});
thunkHelper({
    name: 'loadSearchCustomerContactList_cm',
    request: async (params) => {
        const { limit = 50, parentId, originId } = params || {};
        let customerId = originId || parseTreeKey(parentId);
        const result = await request.doGetCustomerContactList({
            page: 1,
            pageSize: limit,
            id: customerId,
            emailRole: 'myCustomer',
        });
        return result;
    },
    fulfilled: (rootState, action) => {
        const { parentId, sliceId, page: _page, originId } = action.meta.arg || {};
        const state = getCustomerSlice(rootState, sliceId || tabId.readCustomer);
        if (!state) {
            return;
        }
        const customerId = originId || parseTreeKey(parentId);
        const { data } = action.payload;
        const contactList = data.map(transServerCustomerContact2SimpleContactModel);
        state.searchTreeList.forEach(obj => {
            if (obj.key === customerId) {
                const managerList = obj.managerList;
                if (contactList.length === 0) {
                    obj.isLeaf = true;
                }
                obj.children = formatCustomerTreeChild(contactList, managerList);
            }
        });
        state.searchTreeList = [...state.searchTreeList];
    },
});
thunkHelper({
    name: 'loadCustomerGroupList_cm',
    request: async (params, thunkAPI) => {
        const { level, id, sliceId, refresh } = params;
        const rootState = thunkAPI.getState().mailReducer;
        const { dispatch } = thunkAPI;
        const state = getCustomerSlice(rootState, sliceId || tabId.readCustomer);
        if (!state) {
            return;
        }
        if (level === 1) {
            if (!refresh && state.customerGroupList.length) {
                return state.customerGroupList;
            }
            const list = await request.doGetCustomerGroupList({ level, viewType: getCustomerTypeBySliceId(sliceId) });
            const idList = list.map(item => item.id);
            dispatch(Thunks.loadCustomerGroupListNum_cm({ sliceId, idList }));
            return [
                { name: getIn18Text('QUANBU'), id: 'ALL', hasChildren: false },
                { name: getIn18Text('ZUIJINWEILX'), id: MAIL_PLUS_CUSTOMER_GROUP_LATEST_CONTACT, hasChildren: true },
                {
                    name: getIn18Text('WODEGUANZ'),
                    id: MAIL_PLUS_CUSTOMER_GROUP_FAVORITE,
                    hasChildren: false,
                    requestParams: {
                        groupedFilter: request.doGetGroupRequestParams(MAIL_PLUS_CUSTOMER_GROUP_FAVORITE),
                    },
                },
                {
                    name: getIn18Text('WODEJIANK'),
                    id: MAIL_PLUS_CUSTOMER_GROUP_MONITOR,
                    hasChildren: false,
                    requestParams: {
                        groupedFilter: request.doGetGroupRequestParams(MAIL_PLUS_CUSTOMER_GROUP_MONITOR),
                    },
                },
                ...list,
            ];
        }
        if (!id || id === 'ALL') {
            return [];
        }
        if (!refresh && state.customerGroupMap[id]) {
            return state.customerGroupMap[id];
        }
        const list = await request.doGetCustomerGroupList({ level, id, viewType: getCustomerTypeBySliceId(sliceId) });
        return list;
    },
    pending: (rootState, action) => {
        const params = action.meta.arg || {};
        const { sliceId, showLoading = true } = params;
        const state = getCustomerSlice(rootState, sliceId);
        if (!state) {
            return;
        }
        if (showLoading) {
            state.customerListLoading = showLoading;
        }
    },
    fulfilled: (rootState, action) => {
        const { level, id, sliceId, refresh, showLoading = true } = action.meta.arg;
        const list = action.payload;
        const state = getCustomerSlice(rootState, sliceId || tabId.readCustomer);
        if (!state) {
            return;
        }
        if (level === 1) {
            if (!refresh && state.customerGroupList.length) {
                return;
            }
            state.customerGroupList = list;
            state.customerGroupTree = formatCustomerGroup2TreeData(list, '');
            return;
        }
        else {
            state.customerGroupList = [...state.customerGroupList, ...list];
        }
        if (!id || id === 'ALL') {
            state.selectedTreeCustomerGroup1Id = 'ALL';
            return;
        }
        if (!refresh && state.customerGroupMap[id]) {
            if (showLoading) {
                state.customerListLoading = false;
            }
            return;
        }
        const treeData = formatCustomerGroup2TreeData(list, id);
        if (![MAIL_PLUS_CUSTOMER_GROUP_LATEST_CONTACT, MAIL_PLUS_CUSTOMER_GROUP_FAVORITE, MAIL_PLUS_CUSTOMER_GROUP_MONITOR].includes(id)) {
            const item = state.customerGroupList.find(item => item.id === id);
            const firstGroupCount = (item === null || item === void 0 ? void 0 : item.count) || 0;
            if (treeData.length) {
                treeData[0].nodeData.count = firstGroupCount;
            }
            else if (firstGroupCount > 0) {
                treeData.push(createCustomerGroupALL(id, true, firstGroupCount));
            }
        }
        const groupTreeData = insertGroup2TreeData({
            treeData: state.customerGroupTree,
            data: list,
            level,
            parentId: id,
            refresh: refresh,
            page: 0,
            hasMore: false,
        });
        state.customerGroupTree = [...groupTreeData];
        state.customerGroupMap[id] = {
            data: treeData,
            hasMore: false,
            page: 1,
        };
        if (showLoading) {
            state.customerListLoading = false;
        }
        return;
    },
});
thunkHelper({
    name: 'loadCustomerGroupListNum_cm',
    request: async (params, thunkAPI) => {
        const { idList, sliceId } = params;
        const rootState = thunkAPI.getState().mailReducer;
        const state = getCustomerSlice(rootState, sliceId);
        if (!state) {
            return;
        }
        if (idList.length === 0) {
            return {};
        }
        const list = await request.doGetMyCustomerGroup1CountList(idList, getCustomerTypeBySliceId(sliceId));
        return list;
    },
    fulfilled: (rootState, action) => {
        const { sliceId } = action.meta.arg;
        const res = action.payload;
        const state = getCustomerSlice(rootState, sliceId || tabId.readCustomer);
        if (!state) {
            return;
        }
        const newList = [];
        state.customerGroupList.forEach(item => {
            const currentCount = res[item.id];
            const currentData = state.customerGroupMap[item.id];
            if (currentData) {
                const currentTree = currentData.data;
                const firstTreeNode = currentTree[0];
                if (firstTreeNode && firstTreeNode.nodeData) {
                    firstTreeNode.nodeData.count = currentCount;
                    if (state.selectedTreeCustomerGroup1Id === item.id) {
                        state.customerTreeList[0].nodeData.count = currentCount;
                    }
                }
            }
            newList.push(Object.assign(Object.assign({}, item), { count: currentCount }));
        });
        state.customerGroupList = newList;
        state.customerGroupTree = formatCustomerGroup2TreeData(newList, '');
    },
});
thunkHelper({
    name: 'loadCustomerList_cm',
    request: async (params, thunkAPI) => {
        const { dispatch } = thunkAPI;
        const { page, limit = 30, parentId, sliceId, isInit, refresh, level } = params || {};
        const state = getCustomerSlice(thunkAPI.getState().mailReducer, sliceId || tabId.readCustomer);
        if (!state) {
            return;
        }
        const customerGroupMap = state.customerGroupMap;
        const currentData = customerGroupMap[parentId];
        let customerOriginId, customerId, emails = [], managerList = [];
        const requestParams = getCustomerGroupRequestParams(state, level, parentId + '');
        const result = await request.doGetCustomerList({
            page: refresh ? 1 : page,
            pageSize: limit,
            requestParams,
            viewType: getCustomerTypeBySliceId(sliceId),
        });
        const customerIds = result.data.map(v => v.company_id);
        dispatch(Thunks.getUnread_cm({ customerIds }));
        if (isInit) {
            const { data } = result;
            if (data.length) {
                customerOriginId = data[0].company_id;
                managerList = transManagerList2ManagerModel(data[0].manager_list);
                customerId = createTreeKey(customerOriginId, parentId);
            }
        }
        if (customerOriginId || customerId) {
            const customerContactRes = await dispatch(Thunks.loadCustomerContactList_cm({
                sliceId,
                page: 1,
                limit: 50,
                refresh,
                isInit,
                originId: customerOriginId,
                parentId: customerId,
            })).unwrap();
            const { data } = customerContactRes;
            emails = data.filter(item => !!item.email).map(item => item.email);
        }
        return { result, emails, originId: customerOriginId, customerId, managerList };
    },
    pending: (rootState, action) => {
        const params = action.meta.arg || {};
        const { refresh, level, sliceId, parentId, showLoading = true } = params;
        const state = getCustomerSlice(rootState, sliceId || tabId.readCustomer);
        if (!state) {
            return;
        }
        const customerGroupMap = state.customerGroupMap;
        if (showLoading && (refresh || (level === 1 && !customerGroupMap[parentId]))) {
            state.customerListLoading = showLoading;
        }
    },
    fulfilled: (rootState, action) => {
        const { sliceId, refresh, parentId, level, showLoading = true, isInit = false } = action.meta.arg || {};
        const state = getCustomerSlice(rootState, sliceId || tabId.readCustomer);
        if (!state) {
            return;
        }
        const customerGroupMap = state.customerGroupMap;
        const { result: { data, page, totalPage }, emails, originId, customerId, managerList, } = action.payload;
        const hasMore = page < totalPage;
        const customerList = data.map(transServerCustomer2CustomerModel);
        const treeData = insertCustomer2TreeData({
            treeData: state.customerTreeList,
            data: customerList,
            level,
            parentId,
            page,
            hasMore,
            refresh: refresh || page === 1,
        });
        if (isInit) {
            state.selectedGroupKeys.id = parentId;
            state.selectedGroupKeys.originId = parentId;
            state.selectedKeys.originId = originId;
            state.selectedKeys.id = customerId;
            state.selectedKeys.managerList = managerList;
            state.selectedKeys.title = emails[0] || '';
            state.expandedKeys = [customerId];
            state.selectedContacts.list = emails;
            state.customerAsideDetail.email = emails[0] || '';
        }
        if (level === 1) {
            state.customerTreeListHasMore = hasMore;
            state.customerTreeListPage = page;
            customerGroupMap[parentId] = {
                data: treeData,
                hasMore,
                page,
            };
        }
        else {
            const groupData = customerGroupMap[state.selectedTreeCustomerGroup1Id];
            if (groupData) {
                groupData.data = treeData;
            }
        }
        state.customerTreeList = treeData;
        if (showLoading) {
            state.customerListLoading = false;
        }
    },
    rejected: (state, action) => {
        const params = action.meta.arg || {};
        const { sliceId } = params;
        if (!sliceStateCheck(state, sliceId, 'customer')) {
            return;
        }
        if (state.customer[sliceId]) {
            state.customer[sliceId].customerListLoading = false;
        }
    },
});
thunkHelper({
    name: 'loadCustomerContactList_cm',
    request: async (params, thunkAPI) => {
        const { page, limit = 50, parentId, originId, sliceId, refresh } = params || {};
        const state = getCustomerSlice(thunkAPI.getState().mailReducer, sliceId || tabId.readCustomer);
        if (!state) {
            return;
        }
        let customerId = originId || parseTreeKey(parentId);
        const currentData = customerId && state.visitedCustomerMap[customerId];
        console.log('loadCustomerContactList_cm', parentId, originId, currentData);
        if (!refresh && currentData && currentData.page >= page && !currentData.hasMore) {
            return {
                data: currentData.data,
            };
        }
        const result = await request.doGetCustomerContactList({
            page: refresh ? 1 : page,
            pageSize: limit,
            id: customerId,
            emailRole: 'myCustomer',
        });
        return result;
    },
    fulfilled: (rootState, action) => {
        const { sliceId, limit = 50, refresh = false, parentId, page: _page, originId } = action.meta.arg || {};
        const state = getCustomerSlice(rootState, sliceId || tabId.readCustomer);
        if (!state) {
            return;
        }
        const customerId = originId || parseTreeKey(parentId);
        let hasMore, contactList = [], page = _page;
        const currentData = state.visitedCustomerMap[customerId];
        if (!refresh && currentData && currentData.page >= page && !currentData.hasMore) {
            contactList = currentData.data;
            hasMore = currentData.hasMore;
            page = currentData.page;
        }
        else {
            const { data, totalSize } = action.payload;
            page = action.payload.page;
            hasMore = page * limit < totalSize;
            contactList = data.map(transServerCustomerContact2SimpleContactModel);
            state.visitedCustomerMap[customerId] = {
                page,
                hasMore,
                data: contactList,
            };
        }
        const treeData = inserCustomerContact2TreeData({
            treeData: state.customerTreeList,
            data: contactList,
            parentId,
            page,
            hasMore,
            refresh,
        });
        state.customerTreeList = treeData;
        const groupData = state.customerGroupMap[state.selectedTreeCustomerGroup1Id];
        if (groupData) {
            groupData.data = treeData;
        }
    },
    rejected: (state, action) => {
        const params = action.meta.arg || {};
        const { sliceId } = params;
        if (!sliceStateCheck(state, sliceId, 'customer')) {
            return;
        }
    },
});
thunkHelper({
    name: 'getUnread_cm',
    request: async (params, thunkAPI) => {
        const { dispatch } = thunkAPI;
        let { customerIds = [], returnAll = true } = params || {};
        const isOnlyForTotal = customerIds.length === 0;
        if (!isOnlyForTotal) {
            customerIds = customerIds.map(parseTreeKey);
        }
        const res = await request.doCustomersUnread({ customerIds, returnAll });
        dispatch(mailTabActions.doChangeTabById({
            id: tabId.readCustomer,
            tabModel: {
                extra: {
                    unRead: (res.total && formatNumberByMax(res.total, 999)) || '',
                },
            },
        }));
        console.log('[getUnread_cm]', res);
        return { res, isOnlyForTotal };
    },
    fulfilled: (state, action) => {
        var _a;
        const { res, isOnlyForTotal } = action.payload || {};
        if (isOnlyForTotal) {
            return;
        }
        const customerMap = {};
        const contentMap = {};
        if (res && ((_a = res.items) === null || _a === void 0 ? void 0 : _a.length)) {
            res.items.forEach(customItem => {
                if (customItem) {
                    const { customerId, unread: customerUnread, initialized: customerInitialized, contacts, total = 0 } = customItem;
                    customerMap[customerId] = { unread: customerUnread, initialized: customerInitialized, total };
                    for (const contactId in contacts) {
                        const id = customerId + contactId;
                        const targetContact = contacts[contactId];
                        contentMap[id] = { unread: targetContact.unread, initialized: targetContact.initialized, total: targetContact.total || 0 };
                    }
                }
            });
        }
        state.unReadMap_cm.customerMap = Object.assign(Object.assign({}, state.unReadMap_cm.customerMap), customerMap);
        state.unReadMap_cm.contentMap = Object.assign(Object.assign({}, state.unReadMap_cm.contentMap), contentMap);
    },
});
thunkHelper({
    name: 'isSliceExist_cm',
    request: async (params, thunkAPI) => {
        const { sliceId } = params;
        const state = getCustomerSlice(thunkAPI.getState().mailReducer, sliceId);
        return !!state;
    },
});
thunkHelper({
    name: 'initCustomerTabData_cm',
    request: async (params, thunkAPI) => {
        const { fromSliceId, emails, selectedKeys, sliceId } = params;
        const { dispatch } = thunkAPI;
        const state = getCustomerSlice(thunkAPI.getState().mailReducer, sliceId);
        if (state && state.selectedKeys.id) {
            return Promise.reject('isInited');
        }
        let list = emails;
        let email = emails[0];
        if (emails.length === 0 && selectedKeys.nodeType === 'customer') {
            const customerContactRes = await dispatch(Thunks.loadCustomerContactList_cm({
                page: 1,
                parentId: selectedKeys.id,
                limit: 50,
                sliceId: fromSliceId,
                originId: selectedKeys.originId,
            })).unwrap();
            const { data } = customerContactRes;
            list = data.filter(item => !!item.email).map(item => item.email);
            email = list[0];
        }
        return {
            list,
            email,
        };
    },
    fulfilled(rootState, action) {
        const { sliceId, fromSliceId, selectedKeys, type } = action.meta.arg || {};
        const { list, email } = action.payload;
        const state = getCustomerSlice(rootState, sliceId);
        const fromState = getCustomerSlice(rootState, fromSliceId);
        if (!fromState || !state) {
            return;
        }
        state.selectedTreeCustomerGroup1Id = fromState.selectedTreeCustomerGroup1Id;
        const treeList = [...fromState.customerTreeList];
        state.customerTreeList = treeList;
        state.selectedContacts = { list };
        state.selectedKeys = selectedKeys;
        state.customerAsideDetail = { email, type };
        const { rootId: groupId, parentId } = getNodeParentsIdByKey(treeList, selectedKeys.id);
        const expandedKeys = [];
        if (groupId) {
            expandedKeys.push(groupId);
        }
        if (parentId) {
            expandedKeys.push(parentId);
        }
        state.expandedKeys = expandedKeys;
    },
    rejected(state, action) {
        var _a;
        const error = ((_a = action === null || action === void 0 ? void 0 : action.error) === null || _a === void 0 ? void 0 : _a.message) || action.payload || action.error;
        if (error === 'isInited') {
            console.log('jump ');
        }
    },
});
thunkHelper({
    name: 'refreshCustomerData_cm',
    request: async (params, thunkAPI) => {
        var _a;
        const { sliceId, isInit, refresh = true } = params || {};
        const { dispatch } = thunkAPI;
        const state = getCustomerSlice(thunkAPI.getState().mailReducer, sliceId);
        if (!state) {
            return;
        }
        const customerGroupList = await dispatch(Thunks.loadCustomerGroupList_cm({
            level: 1,
            sliceId,
            showLoading: false,
            refresh,
        })).unwrap();
        let level = 2, parentId = '', customerId = '', customerOriginId = '', emails = [];
        if (state.selectedKeys.id) {
            const res = getNodeParentsIdByKey(state.customerTreeList, state.selectedKeys.id);
            parentId = res.rootId || '';
            customerId = res.parentId || '';
            customerOriginId = res.originParentId || '';
        }
        const prevSelectedFirstGroupId = state.selectedTreeCustomerGroup1Id;
        const firstGroup = (_a = customerGroupList) === null || _a === void 0 ? void 0 : _a.find(item => item.id === prevSelectedFirstGroupId);
        if (firstGroup) {
            if (firstGroup.hasChildren) {
                await dispatch(Thunks.loadCustomerGroupList_cm({
                    level: 2,
                    id: prevSelectedFirstGroupId,
                    sliceId,
                    showLoading: false,
                    refresh,
                }));
            }
            else {
                parentId = prevSelectedFirstGroupId;
                level = 1;
            }
        }
        else {
            level = 1;
            parentId = 'ALL';
        }
        if (parentId) {
            const customerRes = await dispatch(Thunks.loadCustomerList_cm({
                sliceId,
                parentId,
                page: 1,
                limit: 50,
                showLoading: false,
                refresh,
                isInit,
                level,
            })).unwrap();
            if (isInit) {
                const { data } = customerRes === null || customerRes === void 0 ? void 0 : customerRes.result;
                if (data === null || data === void 0 ? void 0 : data.length) {
                    customerOriginId = data[0].company_id;
                    customerId = createTreeKey(customerOriginId, parentId);
                }
            }
            if (customerOriginId || customerId) {
                const customerContactRes = await dispatch(Thunks.loadCustomerContactList_cm({
                    sliceId,
                    page: 1,
                    limit: 50,
                    refresh,
                    isInit,
                    originId: customerOriginId,
                    parentId: customerId,
                })).unwrap();
                const { data } = customerContactRes;
                emails = data.filter(item => !!item.email).map(item => item.email);
            }
        }
        return {
            parentId,
            originId: customerOriginId,
            customerId,
            emails,
            firstGroup,
        };
    },
    pending: (rootState, action) => {
        const params = action.meta.arg || {};
        const { sliceId, refresh = true } = params;
        const state = getCustomerSlice(rootState, sliceId || tabId.readCustomer);
        if (!state) {
            return;
        }
        state.refreshBtnLoading = true;
        state.expandedKeys = [];
        state.expandedGroupKeys = [];
        if (refresh) {
            state.customerGroupMap = {};
            state.visitedCustomerMap = {};
        }
        state.customerListLoading = true;
    },
    fulfilled: (rootState, action) => {
        const { sliceId, isInit } = action.meta.arg || {};
        const state = getCustomerSlice(rootState, sliceId);
        if (!state) {
            return;
        }
        const { emails, originId, customerId, parentId, firstGroup } = action.payload || {};
        if (isInit) {
            state.selectedGroupKeys.id = parentId;
            state.selectedGroupKeys.originId = parentId;
            state.selectedKeys.originId = originId;
            state.selectedKeys.id = customerId;
            state.selectedKeys.title = emails[0] || '';
            state.expandedKeys = [customerId];
            state.selectedContacts.list = emails;
            state.customerAsideDetail.email = emails[0] || '';
        }
        else {
            if (!firstGroup) {
                state.selectedTreeCustomerGroup1Id = 'ALL';
                state.selectedGroupKeys = { id: 'ALL', originId: 'ALL' };
                state.expandedKeys = [];
                state.selectedContacts = { list: [] };
                state.selectedKeys = { id: '' };
                state.customerAsideDetail = { email: '', type: '' };
            }
            else {
                state.expandedKeys = [parentId, customerId];
                const node = getNodeDataByKey(state.customerTreeList, state.selectedKeys.id);
                if (!node) {
                    state.selectedContacts = { list: [] };
                    state.customerAsideDetail = { email: '', type: '' };
                }
                else if (node.nodeType === 'group') {
                    state.selectedContacts = { list: [] };
                    state.customerAsideDetail = { email: '', type: '' };
                }
            }
        }
        state.customerListLoading = false;
        state.refreshBtnLoading = false;
        console.log('刷新成功');
    },
});
export const FolderThunks_cm = Thunks;
export const FolderExtraReducersList_cm = ReducersList;
